(function () {
  var THRESHOLD = 40;
  var MOBILE_QUERY = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function bindSwipe(wrapper) {
    if (wrapper.dataset.arSwipeInit) return;
    wrapper.dataset.arSwipeInit = '1';

    var track = wrapper.querySelector('[data-slider-container]') || wrapper;
    var startX = 0;
    var startY = 0;
    var tracking = false;

    track.addEventListener('touchstart', function (e) {
      if (!isMobile()) return;
      var t = e.touches[0];
      if (!t) return;
      startX = t.clientX;
      startY = t.clientY;
      tracking = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      if (!isMobile()) return;

      var t = e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;

      if (Math.abs(dx) < THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;

      var buttons = wrapper.querySelectorAll('[data-slider-button]');
      var nextBtn = null;
      var prevBtn = null;
      buttons.forEach(function (btn) {
        if (btn.hasAttribute('data-slider-button-next')) {
          if (!nextBtn) nextBtn = btn;
        } else if (!prevBtn) {
          prevBtn = btn;
        }
      });

      if (dx < 0 && nextBtn) {
        nextBtn.click();
      } else if (dx > 0 && prevBtn) {
        prevBtn.click();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-slider]').forEach(bindSwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 50);
  });
})();
